var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shopping-cart"},[_c('van-nav-bar',{attrs:{"title":"购物车","fixed":""}}),_c('h1',[_vm._v("shoppingCart")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }